import { createFeatureSelector, createSelector } from '@ngrx/store';
import { projectDetailsInvoiceDetailsState } from './projectDetailsInvoiceDetails.state';

export const getprojectDetailsInvoiceDetailsState = createFeatureSelector<projectDetailsInvoiceDetailsState>('projectDetailsInvoiceDetails');

export const getprojectDetailsInvoiceDetails = createSelector(
  getprojectDetailsInvoiceDetailsState,
  (state) => state.projectDetailsInvoiceDetails
);